import { useGuestPageContainerBySlugQuery } from './Custom.graphql.generated';
import { useEventUserRole } from '@shared/components/AuthProvider';
import { useCurrentPageSlug } from '@shared/utils/hooks/useCurrentPageSlug';
import { useIsCurrentPageSsrFetchEnabled } from '@apps/guest/shared/hooks/useIsCurrentPageSsrFetchEnabled';
import { isInIframe } from '@shared/utils/isInIframe';

/**
 * Prefetches custom page content during SSR so the Custom widget reads from
 * Apollo cache instead of firing a Phase 2 network request.
 *
 * Only fires when the current route is a custom page (e.g., /page/<slug> or
 * a migrated custom page like /dress-code).
 */
export const useFetchCustomPageData = (eventHandle: string, skip?: boolean) => {
  const { isAdmin } = useEventUserRole();
  const isPreviewing = isInIframe();
  const { currentPageSlug, isCustomPageSlug } = useCurrentPageSlug(eventHandle);
  const isSsrEnabled = useIsCurrentPageSsrFetchEnabled(eventHandle, 'custom');

  const { data, loading } = useGuestPageContainerBySlugQuery({
    variables: {
      payload: {
        eventName: eventHandle,
        pageSlug: currentPageSlug ?? '',
      },
      isAdminDashboard: isPreviewing && isAdmin,
    },
    batchMode: 'fast',
    fetchPolicy: 'cache-first',
    ssr: isSsrEnabled,
    skip: skip || !isCustomPageSlug || !currentPageSlug,
  });

  return { data, loading };
};
